export const API_URL =
  // process.env.NODE_ENV === "development"
  //   ? "http://localhost:5001/test-69192/us-central1"
  //   :
  'https://us-central1-test-69192.cloudfunctions.net'
